import { exec, getApiToken } from '../utils';

interface DownloadCatalogFieldMappingsExecVariables {
  token: string;
  partnerCode: string;
}

interface DownloadCatalogFieldMappingsExecResponse {
  restUser: {
    partner: {
      downloadCatalogFields: string;
    };
  };
}

/**
 * Downloads the current catalog field mappings for a given partner as a TSV file.
 *
 * @param partnerCode - The partner code to download mappings for.
 */
export const downloadCatalogFieldMappings = async (
  partnerCode: string,
): Promise<void> => {
  const apiToken = await getApiToken();

  const query = `
    query downloadCatalogFields(
      $partnerCode: String!
      $token: String!
    ) {
      restUser(token: $token) {
        partner(code: $partnerCode) {
          downloadCatalogFields
        }
      }
    }
  `;

  const data = await exec<DownloadCatalogFieldMappingsExecVariables, DownloadCatalogFieldMappingsExecResponse>(
    query,
    {
      variables: {
        token: apiToken,
        partnerCode,
      },
    },
  );

  const tsv = data.restUser.partner.downloadCatalogFields;

  // Trigger browser download
  const blob = new Blob([tsv], { type: 'text/tab-separated-values' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `catalog-fields-mapping-${partnerCode}.tsv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
